import React, { FC } from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
  renderTertiaryBlock,
  renderSecondaryBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";

import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";

import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";
// eslint-disable-next-line import/no-extraneous-dependencies
import getEvents from "./js/webflow";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

const Component: FC<ContentCollectionType> = ({
  PrimaryBlocks,
  TertiaryBlock,
  SecondaryBlock,
  tagline,
  title,
  description,
}: ContentCollectionType) => (
  <Box className="primary-collection-content-collection-two-col-timeline-v1">
    <Box className="page-wrapper timeline-on-page">
      <Box className="section_layout352 layout352_component">
        <Variants.TimelineBackground className="layout352_heading padding-global container-small padding-section-large text-align-center">
          {tagline && (
            <Box className="margin-bottom margin-xsmall">
              <Variants.TagLine>{tagline}</Variants.TagLine>
            </Box>
          )}
          <Box className="margin-bottom margin-small">
            <Variants.Heading>{title}</Variants.Heading>
          </Box>
          <Variants.ParagraphMedium className="text-size-medium">
            {description}
          </Variants.ParagraphMedium>
          {SecondaryBlock && renderSecondaryBlock(SecondaryBlock)}
          {TertiaryBlock && renderTertiaryBlock(TertiaryBlock)}
        </Variants.TimelineBackground>
        <Box className="layout352_timeline padding-global container-large layout352_layout">
          <Variants.TimelineProgress className="layout352_progress">
            <Variants.TimelineIndicator className="layout352_progress-bar" />
            <Variants.TimelineFade top className="layout352_fade-overlay-top" />
            <Variants.TimelineFade className="layout352_fade-overlay-bottom" />
          </Variants.TimelineProgress>
          {PrimaryBlocks?.map((primaryBlockProps, i) => (
            <ContentCollectionItem key={i} {...primaryBlockProps} />
          ))}
        </Box>
        <Variants.TimelineBackground className="layout352_heading padding-global container-small padding-section-large text-align-center">
          {tagline && (
            <Box className="margin-bottom margin-xsmall">
              <Variants.TagLine>{tagline}</Variants.TagLine>
            </Box>
          )}
          <Box className="margin-bottom margin-small">
            <Variants.Heading>{title}</Variants.Heading>
          </Box>
          <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
          {SecondaryBlock && renderSecondaryBlock(SecondaryBlock)}
          {TertiaryBlock && renderTertiaryBlock(TertiaryBlock)}
        </Variants.TimelineBackground>
      </Box>
    </Box>
  </Box>
);

const ComponentWithWebflow = webflowHOC(Component, [
  {
    module: "ix2",
    getEvents: (pageId): object => getEvents(pageId),
  },
]);

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks, ...props }: ContentCollectionType) => (
    <ComponentWithWebflow PrimaryBlocks={PrimaryBlocks} {...props} />
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
